<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="cont"><a class="nounder" href="#/xhtml/ch00_fm07_ack#ch00_fm07_ack"><em>Acknowledgments</em></a></p>
<p class="cont"><a class="nounder" href="#/xhtml/ch00_fm08_intro#ch00_fm08_intro">Introduction</a></p>
<p class="cont1"><a class="nounder" href="#/xhtml/ch01#ch01">1     Material Life in West and West Central Africa, 1650–1800</a></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2     Seeds of Change: African Agricultural Workers in the Anglo-American Colonies</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3     Cultivating Knowledge: African Tobacco and Cotton Workers in Colonial British America</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4     In an Ocean of Blue: West African Indigo Workers in the Atlantic World to 1800</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5     Slave Artisans: Black Nonagricultural Workers in Colonial America and the Antebellum South</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6     Natural Worship: Slavery, the Environment, and Black Consciousness in the Antebellum South</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch07_notes#ch07_notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch08_bib#ch08_bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch09_index#ch09_index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch10_abt#ch10_abt" title="Link target outside of Sample"><em>About the Author</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_cont.vue?7dc8b498